import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const FullTextIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3 14.8333L3.33333 2.16665L13 1.83331V10.8333L8.66667 14.8333H3Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        d="M9.15446 11.1422L13.1789 11.1422L9.15446 15.1666L9.15446 11.1422Z"
        fill="currentColor"
      />
      <path
        d="M13.1792 10.4755C13.4487 10.4756 13.6919 10.638 13.7951 10.887C13.8982 11.136 13.8411 11.4229 13.6506 11.6135L9.62581 15.6383C9.43515 15.8288 9.1483 15.886 8.89925 15.7828C8.65023 15.6797 8.48791 15.4365 8.48779 15.1669L8.48779 11.1422C8.48779 10.774 8.78627 10.4755 9.15446 10.4755L13.1792 10.4755ZM9.82113 13.5569L11.5692 11.8089L9.82113 11.8089L9.82113 13.5569Z"
        fill="currentColor"
      />
      <path
        d="M9.15428 15.8333L9.22003 15.83C9.37272 15.815 9.51617 15.7474 9.62563 15.638L13.6504 11.6139C13.7754 11.4889 13.8457 11.3187 13.8457 11.1419L13.8457 1.83329C13.8457 1.46514 13.5472 1.16669 13.179 1.16663L2.80857 1.16663C2.63177 1.16663 2.46224 1.23693 2.33722 1.36194C2.2122 1.48696 2.14191 1.65648 2.14191 1.83329L2.14191 15.1666C2.14191 15.3434 2.2122 15.513 2.33722 15.638C2.46224 15.763 2.63177 15.8333 2.80857 15.8333L9.15428 15.8333ZM3.47524 2.49996L12.5124 2.49996V10.8658L8.87824 14.5L3.47524 14.5L3.47524 2.49996Z"
        fill="currentColor"
      />
      <path
        d="M9.78386 4.12238C9.99242 3.81901 10.4075 3.74201 10.7109 3.9505C11.0143 4.15907 11.0913 4.57419 10.8828 4.87759L7.67448 9.54425C7.55011 9.72516 7.34454 9.83332 7.12501 9.83332C6.90547 9.83332 6.6999 9.72516 6.57553 9.54425L5.11719 7.42316L5.08139 7.36522C4.91899 7.06884 5.00459 6.69165 5.28907 6.49608C5.57343 6.30062 5.95589 6.35578 6.17448 6.61326L6.21615 6.66795L7.12435 7.98957L9.78386 4.12238Z"
        fill="var(--cdl-accent-fg-base)"
      />
    </svg>
  );
};

export default FullTextIcon;
